<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-11-30 10:27:33
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-13 18:29:29
-->
<template>
  <!-- 仅支持全量树，懒加载树不支持 -->
  <el-select v-model="selectVal" :placeholder="placeholder" clearable ref="select">
    <!-- 模糊检索全量树 -->
    <div style="padding: 0 8px">
      <el-input
        class="input"
        placeholder="此处输入搜索查询"
        prefix-icon="el-icon-search"
        v-model="treeFilterName"
        clearable
      ></el-input>
    </div>
    <el-option hidden key="id" :value="selectVal" :label="selectName"> </el-option>
    <el-tree
      :data="options"
      :props="defaultProps"
      @node-click="handleNodeClick"
      :expand-on-click-node="false"
      :check-on-click-node="true"
      ref="tree"
      :node-key="nodeKey"
      :default-expand-all="defaultExpandAll"
      :filter-node-method="filterNode"
    >
      <template #default="{ node }">
        <span>{{ node.label }}</span>
      </template>
    </el-tree>
  </el-select>
</template>
<script>
  export default {
    name: 'XSelectTree',
    inheritAttrs: true,
    model: {
      prop: 'result',
      event: 'selected'
    },
    props: {
      options: {
        type: Array,
        default: () => []
      },
      nodeKey: {
        type: String,
        default: 'id'
      },
      defaultProps: {
        type: Object,
        default: () => {
          return { children: 'children', label: 'name', value: 'id' }
        }
      },
      placeholder: {
        type: String,
        default: '请选择'
      },
      defaultExpandAll: {
        type: Boolean,
        default: true
      },
      result: [String]
      // data: Object
    },
    data() {
      return {
        selectVal: null,
        selectName: null,
        currentNode: null,
        treeFilterName: ''
      }
    },
    computed: {
      getData() {
        return this.result
      }
      // currentNode: {
      //   get() {
      //     return this.data
      //   },
      //   set(val) {
      //     this.$emit('update:data', val)
      //   }
      // }
    },
    watch: {
      // 搜索过滤，监听input搜索框绑定的treeFilter
      treeFilterName(val) {
        this.$refs.tree.filter(val)
        // 当搜索框键入值改变时，将该值作为入参执行树形控件的过滤事件filterNode
      },
      getData: {
        handler(newValue) {
          if (newValue !== this.selectVal) {
            this.$nextTick(() => {
              this.currentNode = this.$refs.tree.getNode(this.result)?.data
              if (this.currentNode) {
                this.selectName = this.currentNode[this.defaultProps.label]
                this.selectVal = this.result
              }
            })
          }
        },
        immediate: true,
        deep: true
      }
    },
    methods: {
      handleTreeResult() {
        // const data = {
        //   ...this.currentNode,
        //   value: this.selectVal,
        //   name: this.selectName
        // }
        this.$emit('selected', this.selectVal)
      },
      filterNode(value, data) {
        if (!value) return true
        return data[this.defaultProps.label].indexOf(value) !== -1
      },
      handleNodeClick(node) {
        this.currentNode = node
        this.selectVal = node[this.defaultProps?.value ?? 'id']
        this.selectName = node[this.defaultProps.label]
        this.treeFilterName = ''
        this.$refs.select.blur()
        this.handleTreeResult()
      },
      handleSelectFocus() {
        this.$refs.select.focus()
        this.$refs.select.toggleMenu()
      },
      handleSelectBlur() {
        this.$refs.select.blur()
      }
    }
  }
</script>
